class LoyaltyFixedBackground extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setOverlayOpacity()
  }

  setOverlayOpacity () {
    const maxOpacity = 1

    const totalScrollAmount = window.innerHeight

    const scrollYAsAPercentageOfJourney = this.lastKnownY / totalScrollAmount

    const opacityAmount = maxOpacity * scrollYAsAPercentageOfJourney

    this.els.overlay.element.style.setProperty('--Overlay', opacityAmount)
  }
}

if (!customElements.get('loyalty-fixed-background')) {
  customElements.define('loyalty-fixed-background', LoyaltyFixedBackground)
}
